import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';
import * as $ from 'jquery';

import * as _ from 'lodash';
import ProductSelector from '@/components/productSelector/ProductSelector';
import { ProductDefinition, AnimationDefinition } from '@/models/configuratorx/configuratorSchema';

const AnimationOrdersByOrderAttribute = {
  // Ayarlanabilir Boyun Desteği
  neck_support_angle: 10, // Açı Ayarı
  neck_support_height: 20, // Yükseklik Ayarı
  // Ayarlanabilir Sırt Hareketleri
  backrest_tilt: 30, //  Sırt Eğimi
  backrest_height: 40, // Sırt Yüksekliği
  lumbar_support: 50, //  Sırt Yüksekliği
  // Ayarlanabilir Kolçak Hareketleri
  armrest_height: 60, // Yukarı - Aşağı
  armrest_movement: 70, // İleri - Geri
  armrest_rotation: 80, // Bilek Hareketi
  armrest_ped: 80, // Kolcak Pedi Genişliği
  armrest_width: 90, // Genişlik Hareketi
  // Ayarlanabilir Oturma Hareketleri
  seat_height: 100, // Oturma Yüksekliği
  seat_slide: 110, // Oturma Derinliği
  seat_angle: 120, // Oturma Açısı
  mobility_flexibility: 130, // Hareket Esnekliği (sağa,sola yatma)
  tansiyon: 140, // Tansiyon
  weight_adjustment: 150, // The backrest tension can be adjusted to your
};

@Component({
  components: {

  },
})
export default class Animation extends Vue {
  private _configuratorService: ConfiguratorService = undefined;

  @Inject()
  private _container: ComponentContainer;

  @Prop()
  animations: AnimationDefinition[];

  private currentAnimation: AnimationDefinition = null;
  private _animationTimers: number[] = [];
  private _timers: Timer[] = [];

  public get animationsList()
  {
    let sortedAnimations = [];
    if (this.animations) {
      sortedAnimations = _.sortBy(this.animations, [(an) => {
        const index = AnimationOrdersByOrderAttribute[an.name];
        if (typeof index === 'undefined')
        {
          console.log("typeof index === 'undefined'");
          return an.order;
        }
        return index;
      }]);
    }

    return sortedAnimations;
  }

  private initialCamera: Camera = null;

  async created() {
    this._configuratorService = this._container.get<ConfiguratorService>(ServiceIdentifiers.ConfiguratorService);
    this.initialCamera = await this._configuratorService.Client.getCameraLookAt();
  }


  public async initialize(): Promise<any> {
    let time = 0;
    try {
      time = await this._configuratorService.Client.getCurrentTimeOfAnimation();
    } catch (error) {
      time = 0;
    }

    if (time > 0) {
      await this.terminateSpecs(this.currentAnimation);
    }
  }

  public get specContent() {
    const an = this.currentAnimation;
    if (!an) {
      return null;
    }
    return an.content;
  }

  public playPauseSpec = (spec: AnimationDefinition, _currentAnimation: AnimationDefinition): void => {
    //console.log("spec.name: " + spec.name);
    if (_currentAnimation)
    {
      //console.log("_currentAnimation.name: " + _currentAnimation.name);
      this.currentAnimation = _currentAnimation;
    }
    else
    {
      this.currentAnimation = null;
    }
    
    //if (this.currentAnimation)
    //{
    //  console.log("this.currentAnimation.name: " + this.currentAnimation.name);
    //}
    //else
    //{
    //  console.log("NULLLLLLLLLLLLLLLLLLLLLLLL");
    //}
    //if (this.currentAnimation === null)
    //{
    //  console.log("RRRRRRRRRRRRRRRRNULLLLLLLLLLLLLLLLLLLLLLLL");
    //}

    if (this.currentAnimation == null)
    {
      //console.log("this.currentAnimation == null");
      this.showSpec(spec);

    } else if (this.currentAnimation === spec)
    {
      //console.log("this.currentAnimation :" + this.currentAnimation.name);
      //console.log("this.currentAnimation === spec");
      this.terminateSpecs(this.currentAnimation).then(() =>
      {
        return 5;
      });
    }
    else
    {
      //console.log("this.currentAnimation != spec");
      this.terminateSpecs(this.currentAnimation).then(() => {
        return this.showSpec(spec);
      });
    }

    //if (this.currentAnimation !== spec) {
    //  this.terminateSpecs().then(() => {
    //    return this.showSpec(spec);
    //  });

    //} else {
    //  this.terminateSpecs();
    //}
  }

  public playAllAnimations = (_currentAnimation): void => {
    this.terminateSpecs(_currentAnimation).then(() =>
    {
      return this.playAnimationWithIndex(0);
    });
  }

  private playAnimationWithIndex = (index: number): void => {
    const animations = this.animationsList;
    if (animations.length - 1 < index) {
      return;
    }
    const animation = animations[index];

    this.playAnimationInner(animation, animation.runCount || 3, undefined, (a, a2) => {
      this.playAnimationWithIndex(index + 1);
    });
  }

  public playAllSpecs = (): void => {
    this.terminateSpecs(this.currentAnimation);
    this.showSpecWithIndex(0);
  }

  private showSpecWithIndex = (index: number): void => {
    const specs = this.animations;
    if (specs.length - 1 < index) {
      return;
    }
    const spec = specs[index];

    if (spec.animationName) {
      this.playAnimationInner(spec, spec.runCount || 3, undefined, (a, a2) => {
        this.showSpecWithIndex(index + 1);
      });
    } else {
      this.playAnimationInner(spec, spec.runCount || 3, undefined, (a, a2) => {
        this.showSpecWithIndex(index + 1);
      });
    }
  }

  private showSpec(spec: AnimationDefinition): Promise<any> {
    if (spec.animationName) {
      return this.playAnimationInner(spec, spec.runCount || 3);
    }
    return this.showAnnotation(spec);
  }

  private async showAnnotation(annotation: AnimationDefinition): Promise<any> {
    this.currentAnimation = annotation;
    await this._configuratorService.gotoAnnotation(annotation.annotationIndex);

    if (annotation.commands && annotation.commands.selected) {

      await Promise.all(_.map(annotation.commands.selected, (c) => {
        return this._configuratorService.execute(c.type, c);
      }));
    }
    const duration = 5000; // annotation.duration > 0 ? annotation.duration * 1000 : 5000;
    const timer = new Timer(duration);
    this._timers.push(timer);
    await timer.asPromise();
    if (this.currentAnimation !== annotation) {
      return;
    }
    await this.terminateSpecs(this.currentAnimation);
  }

  private async playAnimationInner(spec: AnimationDefinition, initStep: number, currentStep?: number,
    finishedCallback?: (specDefinition: AnimationDefinition, animation: Animation) => void): Promise<any> {

    const an = _.find(this._configuratorService.Client.animations, x => x.name === spec.animationName);
    if (!an) {
      return;
    }
    if (typeof currentStep === 'undefined') {
      // tslint:disable-next-line:no-parameter-reassignment
      currentStep = initStep;
    }

    const isLastStep = currentStep <= 0;
    const isFirstStep = currentStep === initStep;
    //const focusAnnotation = spec.annotationIndex != null && isFirstStep;

    if (!isFirstStep && this.currentAnimation === null) {

      return;
    }

    if (isLastStep) {
      await this.terminateSpecs(this.currentAnimation);
      if (finishedCallback) {
        finishedCallback(spec, an as any);
      }
      return;
    }

    await this._configuratorService.Client.setAnimation(an.uid);
    await this._configuratorService.Client.pauseAnimation();

    const speed = 1; // spec.speed || 1
    const animationDuration = an.duration * 1000; //  spec.duration > 0 ? spec.duration * 1000 : an.duration * 1000
    const seek = 0; // spec.startFrame || 0

    if (!isFirstStep && this.currentAnimation === null)
    {
      //console.log("returned without playing");
      return;
    }
    if (spec.commands && spec.commands.selected) {
      await Promise.all(_.map(spec.commands.selected, (c) => {
        return this._configuratorService.execute(c.type, c);
      }));
    }

    if (isFirstStep) {
      if (spec.commands && spec.commands.camera) {

        await this._configuratorService.Client.lookat(spec.commands.camera.position, spec.commands.camera.target, 1);
      }
    }

    await this._configuratorService.Client.setAnimationsetSpeed(speed);

    if (currentStep === initStep) {
      this.currentAnimation = spec;
      //console.log("zzzzzzzzzzzzzzzzzzzzzzz");
      //console.log(this.currentAnimation.name);
    }

    try {
      await this.seekAnimationTo(seek);
      //console.log(" await this.seekAnimationTo(seek);");
      await this._configuratorService.Client.playAnimation();
      //console.log("await this._configuratorService.Client.playAnimation();");
      await this.seekAnimationTo(seek);
      //console.log("await this.seekAnimationTo(seek);");
      //if (focusAnnotation) {
      //  await this._configuratorService.gotoAnnotation(spec.annotationIndex);
      //  console.log("await this._configuratorService.gotoAnnotation(spec.annotationIndex);");
      //}

      const timer = new Timer(animationDuration);
      //console.log("const timer = new Timer(animationDuration);   :" + animationDuration);
      this._timers = [];
      //console.log(this._timers);
      this._timers.push(timer);
      //console.log("this._timers.push(timer);");
      await timer.asPromise();
      //console.log("await timer.asPromise();");

      if (this.currentAnimation !== spec)
      {
        //console.log("returned because this.currentAnimation !== spec");
        return;
      }

      //console.log("spec.name: " + spec.name);
      //console.log("initStep: " + initStep);
      //console.log("currentStep - 1: " + (currentStep - 1));
      //console.log("finishedCallback: " + finishedCallback);


      await this.playAnimationInner(spec, initStep, currentStep - 1, finishedCallback);

    }
    catch (error)
    {
      //console.log(this._timers);
      //console.log("returned because error await this.playAnimationInner");

      await this.terminateSpecs(this.currentAnimation);
    }
  }

  public async terminateSpecs(_currentAnimation: AnimationDefinition): Promise<any>
  {
    //if (this.currentAnimation)
    //{
    //  console.log("terminateSpecs beginning this.currentAnimation: " + this.currentAnimation.name);
    //}
    //else
    //{
    //  console.log("terminateSpecs beginning this.currentAnimation: NULL");
    //}
    
    await this._configuratorService.Client.pauseAnimation();
    _.each(this._timers, t => t.cancel());
    this._timers = [];
    const an = _currentAnimation;

    if (an == null)
    {
      //console.log("an == null");
      //console.log("an == null this.currentAnimation: " + this.currentAnimation.name);
      //await this.seekAnimationTo(0);
      return;
    }

    await this.seekAnimationTo(0);
    // if (!an.stopOnLastFrame) {
    //   await this.seekAnimationTo(0);
    // }

    if (an.commands) {
      //if (an.commands.camera) {
      //  await this._configuratorService.Client.lookat(this.initialCamera.position, this.initialCamera.target, 1);
      //}

      if (an.commands.destroyed) {
        await Promise.all(_.map(an.commands.destroyed, (c) => {
          return this._configuratorService.execute(c.type, c);
        }));
      }
    }

    this.currentAnimation = null;
    await this.cameraToInitialPosition();
  }

  public async cameraToInitialPosition(): Promise<any>
  {
        await this._configuratorService.Client.lookat(this.initialCamera.position, this.initialCamera.target, 1);
  }

  private async seekAnimationTo(seek: number): Promise<any> {
    try {
      await this._configuratorService.Client.seekAnimationTo(0);
    } catch (error) {
      return Promise.resolve(true);
    }
  }

  mounted()
  {
    $('#optionTab').click(function () {
      $('#terminateAnimationButton').click();
         //console.log("clicked")
    });

    $('#modelTab').click(function () {
      $('#terminateAnimationButton').click();
      //console.log("clicked")
    });

  }
}

export class Timer {
  private _onComplete: () => void;
  private _timeout: number;
  private _promise: Promise<any>;
  private _isCancelled = false;
  private _resolve: (value?: any) => void;
  private _reject: (value?: any) => void;

  constructor(ms, onComplete?: () => void) {
    this._onComplete = onComplete;
    this._promise = new Promise((resolve, reject) => {
      this._reject = reject;
      this._resolve = resolve;
      this._timeout = window.setTimeout(() => {
        this.cancel();
      }, ms);
    });
  }

  public asPromise(): Promise<any> {
    return this._promise;
  }

  public cancel() {
    if (this._isCancelled) {
      return;
    }
    this._resolve('done');
    this._isCancelled = true;
    clearTimeout(this._timeout);
    if (this._onComplete) {
      this._onComplete();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/animation/Animation.ts